import { ClientHelper } from 'utils/ClientHelper';

/**
 * Global instance containing all API clients.
 */
export const client = new ClientHelper();

export const { sdClient, sdClientMetadata } = client;
